/* eslint-disable react-hooks/exhaustive-deps */

import React, {cloneElement, useEffect, useRef} from 'react';
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import MenuBar from "./menuBar";
import {makeStyles} from "@material-ui/core/styles";
import 'firebase/auth';
import AuthUser from "../AuthUser";
import useLayoutStore from "../../../layoutStore";
import usePersistentStore from "../../../persistentStore";
import {Redirect, Route, Switch, useRouteMatch} from "react-router-dom";
import {NavRoutes} from "../../navRoutes";
import Container from "@material-ui/core/Container";
import * as STATES from "../../../constants/states";
import CircularProgress from "@material-ui/core/CircularProgress";
import {amInIFrame, amInPopup} from "../../../utils/utils";

// TODO low - MainMenu - make JunctionBox clickable

const inIFrame = amInIFrame();
const inPopup = amInPopup();

const useStyles = makeStyles(theme => ({
    grow: {
        flexGrow: 1,
    },
    navigation: {
        marginBottom: 0
    },
    iFrameNavigation: {
        marginBottom: 0,
        minHeight: 0
    },
    toolbar: {
        marginBottom: 0
    },
    iFrameToolbar: {
        marginBottom: 0,
        minHeight: 0
    },
    appTitle: {
        marginRight: 10
    }
}));

const MainMenu = (props) => {
    const classes = useStyles();
    const navigationRef = useRef();
    // eslint-disable-next-line no-unused-vars
    const [globalLayoutState, globalLayoutActions] = useLayoutStore();
    const [globalPersistentState] = usePersistentStore();
    let {url} = useRouteMatch();

    useEffect(() => {
        if (navigationRef.current) globalLayoutActions.setHeaderHeight(navigationRef.current.clientHeight);
    }, [globalLayoutActions, navigationRef]);

    const routes = NavRoutes();

    return (
        <>
            <AuthUser/>
            {!inPopup && <div id="outside-appbar" ref={navigationRef} className={classes.grow}>
                <AppBar id="navBar" position="sticky"
                        className={inIFrame ? classes.iFrameNavigation : classes.navigation}>
                    <Toolbar className={inIFrame ? classes.iFrameToolbar : classes.toolbar}>
                        <Typography
                            variant="h6"
                            color="inherit"
                            className={classes.appTitle}
                        >
                            {routes.root.title}
                        </Typography>
                        <div>
                            {(globalPersistentState.state === STATES.LOGGING_IN || globalPersistentState.state === STATES.LOGGING_OUT) && (
                                <CircularProgress color="inherit"/>
                            )}
                        </div>
                        <MenuBar
                            {...props}
                            url={url}
                            parent={routes.root}
                        />
                    </Toolbar>
                </AppBar>
            </div>}
            <Switch>
                <Redirect exact from={routes.root.redirectMatch} to={routes.root.redirectSlash}/>
                {Object.keys(routes.root.routes).map((key, idx) => {
                    const route = routes.root.routes[key];
                    if (route.path && route.component) {
                        return <Route key={idx} path={`${route.path}`}>
                            <Container>
                                {cloneElement(
                                    route.component,
                                    {
                                        ...props,
                                        parent: route
                                    }
                                )}
                            </Container>
                        </Route>
                    }
                    return null;
                })}
            </Switch>
        </>
    )
};

export default MainMenu;
